import { render, staticRenderFns } from "./ics.vue?vue&type=template&id=6a824021&scoped=true"
import script from "./ics.vue?vue&type=script&lang=js"
export * from "./ics.vue?vue&type=script&lang=js"
import style0 from "./ics.vue?vue&type=style&index=0&id=6a824021&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a824021",
  null
  
)

export default component.exports